import React from "react";
import { graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import Layout from "../components/Layout";
import SearchEngineOptimization from "../components/SEO";
import BlogPostList from "../components/Blog/BlogPostList";
import {
  filterOutDocsPublishedInTheFuture,
  filterOutDocsWithoutSlugs,
  mapEdgesToNodes,
} from "../lib/helpers";
import CallToAction from "../components/Repeating/CTA";

export const query = graphql`
  {
    openGraphImage: file(
      relativePath: { eq: "open-graph/facebook/Global.jpg" }
    ) {
      publicURL
    }
    twitterOpenGraphImage: file(
      relativePath: { eq: "open-graph/twitter/Global.jpg" }
    ) {
      publicURL
    }
    blogs: allSanityBlogs(
      sort: { fields: [publishedAt], order: DESC }
      filter: { slug: { current: { ne: null } }, publishedAt: { ne: null } }
    ) {
      edges {
        node {
          id
          publishedAt
          featuredImage {
            asset {
              gatsbyImageData
            }
          }
          categories {
            _id
            title
          }
          title
          slug {
            current
          }
          _rawBody(resolveReferences: { maxDepth: 5 })
        }
      }
    }
  }
`;

const Page = ({ data }) => {
  const postNodes =
    data &&
    data.blogs &&
    mapEdgesToNodes(data.blogs)
      .filter(filterOutDocsWithoutSlugs)
      .filter(filterOutDocsPublishedInTheFuture);

  return (
    <Layout>
      <SearchEngineOptimization
        title="News | Assurance Capital"
        description="Get Assurance Capital company news and investment announcements in our news feed. Contact us to learn more about investing in your own business."
        // openGraphImage={data.openGraphImage.publicURL}
        // twitterOpenGraphImage={data.twitterOpenGraphImage.publicURL}
      />

      <section className="relative overflow-hidden py-20 text-center md:py-36">
        <div className="absolute top-0 left-0 h-full w-full">
          <StaticImage
            src="../images/5.0 News/1.0 hero BG.jpg"
            loading="eager"
            className="h-full"
          />
        </div>
        <div className="container relative">
          <h1 className="mb-0 text-white">News</h1>
        </div>
      </section>

      <section className="pt-16 pb-20 md:pt-26 md:pb-32">
        <div className="container">
          <div className="grid gap-y-6 md:grid-cols-12 md:gap-x-10 lg:gap-x-16">
            <div className="md:col-span-8 md:col-start-1">
              {postNodes && postNodes.length > 0 && (
                <BlogPostList nodes={postNodes} />
              )}
            </div>
            <div className="md:col-span-4 md:col-end-13">
              <div className="sticky top-32 md:ml-auto md:max-w-[296px]">
                <div className="rounded-md bg-primary-50 px-6 py-6 text-center">
                  <StaticImage
                    src="../images/5.0 News/Logo.png"
                    loading="lazy"
                    width={80}
                    className="mb-6"
                  />
                  <p className="text-geay-500 text-sm">
                    Assurance Mezzanine Fund was created by former industry
                    executives and experienced investors. Follow us on LinkedIn.
                  </p>
                  <a
                    href="https://www.linkedin.com/company/assurance-mezzanine-fund/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-secondary-900 no-underline hover:text-secondary-500"
                  >
                    <i className="fab fa-linkedin-in text-xl"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CallToAction />
    </Layout>
  );
};

export default Page;
